import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="policy-container">
      <h1>Terms and Conditions</h1>

      <p>
        Welcome to <strong>Ora Bike</strong>. These terms and conditions outline the rules and guidelines for using our electric vehicles, services, and website. By using our products or services, you agree to abide by the following terms.
      </p>

      <h2>1. Product Usage Guidelines</h2>
      <ul>
        <li>
          Batteries must be protected from water exposure. Immersing or washing the battery or vehicle in water will void the warranty.
        </li>
        <li>
          The vehicle should not be left exposed to fire, extreme heat, or direct sunlight for extended periods, especially on wiring or battery areas.
        </li>
        <li>
          Overloading or using the vehicle in conditions beyond recommended limits may result in damage and is not covered by warranty.
        </li>
      </ul>

      <h2>2. Mandatory Servicing</h2>
      <p>
        It is mandatory to get the vehicle serviced at an authorized Ora Bike service center at regular intervals, as specified in the user manual or warranty card. Failure to do so may void warranty eligibility.
      </p>

      <h2>3. Limited Liability</h2>
      <p>
        Ora Bike will not be held responsible for any damage caused by negligence, misuse, improper maintenance, or use of unauthorized components or services.
      </p>

      <h2>4. Orders and Payments</h2>
      <ul>
        <li>All orders are subject to product availability and confirmation.</li>
        <li>Prices may vary without prior notice and are subject to applicable taxes.</li>
        <li>We reserve the right to cancel or refuse any order without explanation.</li>
      </ul>

      <h2>5. Shipping and Delivery</h2>
      <p>
        Estimated delivery times may vary depending on location and logistics. We do not take responsibility for delays caused by transport providers.
      </p>

      <h2>6. Returns and Refunds</h2>
      <p>
        Please refer to our <a href="/refund-policy">Refund Policy</a> for details about returns, refunds, and warranty claims.
      </p>

      <h2>7. Intellectual Property</h2>
      <p>
        All content on our website and branded materials (including logos, images, and documentation) are the intellectual property of Ora Bike and may not be copied without written permission.
      </p>

      <h2>8. Modification of Terms</h2>
      <p>
        Ora Bike reserves the right to modify these terms at any time. Continued use of the vehicle or our services constitutes acceptance of any updates.
      </p>

      <h2>9. Contact Information</h2>
      <p>
        If you have any questions or concerns regarding these terms, please reach out to us at:<br />
        <strong>info@orabike.in</strong><br />
       +91-2269711724
      </p>
    </div>
  );
};

export default TermsAndConditions;
